import dateWindowEffective from 'root-packages/dates/dateWindowEffective.js'
import LocalDate from '@booking-services/localDate'

export default function ({discount: discountOrPromotion, bookingDate, departureDate, travelDateWindowEndExclusive}) {
  const travelDate = departureDate ? new LocalDate(departureDate) : departureDate
  const bookingDateEffective = dateWindowEffective({
    dateWindow: discountOrPromotion.bookingDateWindow,
    date: bookingDate,
  })
  const travelDateEffective = dateWindowEffective({
    // this fallback is required because this function is used by Discounts and Promotions
    //  and Discounts does not have a travelDateWindows property
    dateWindow: discountOrPromotion.travelDateWindows || discountOrPromotion.travelDateWindow,
    date: travelDate,
    toExclusive: travelDateWindowEndExclusive,
  })

  return bookingDateEffective && travelDateEffective
}
